"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _antd = require("antd");
var _TreeSelect = require("./TreeSelect.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * 多選下拉多層選單
 */ // const { SHOW_PARENT } = AntTreeSelect;
const TreeSelect = _ref => {
  let {
    label,
    options,
    onChange,
    value,
    placeholder,
    getPopupContainer = () => document.getElementById("area")
  } = _ref;
  const onChangeHandle = value => {
    onChange && onChange(value);
  };
  return /*#__PURE__*/_react.default.createElement(_TreeSelect.UiTreeSelect, {
    id: "area"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "label"
  }, label), /*#__PURE__*/_react.default.createElement(_antd.TreeSelect, {
    style: {
      minWidth: "240px",
      maxWidth: "350px"
    },
    placeholder: placeholder,
    treeData: options,
    getPopupContainer: getPopupContainer,
    value: value,
    onChange: onChangeHandle,
    treeCheckable: true
  }));
};
var _default = exports.default = TreeSelect;
TreeSelect.propTypes = {
  label: _propTypes.default.string,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string,
    value: _propTypes.default.string,
    key: _propTypes.default.string,
    children: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string,
      value: _propTypes.default.string,
      key: _propTypes.default.string
    }))
  })),
  onChange: _propTypes.default.func,
  value: _propTypes.default.any,
  placeholder: _propTypes.default.string,
  getPopupContainer: _propTypes.default.func
};